import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../media-query';
import {
  centeredRowBox,
  extraSmallMarginBottomBox,
  extraSmallPaddingVerticalBox,
  largePaddingHorizontalBox,
  mediumNegativeMarginTopBox,
  largePaddingBottom,
  mediumPaddingHorizontalBox,
} from '../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    ...maxContainerWidthStyle,
  },
  section: {
    flex: 1,
  },
  image: {
    height: mediaQuery.smallImage,
  },
  titleContainer: {
    display: 'flex',
    ...centeredRowBox,
    ...extraSmallPaddingVerticalBox,
    ...mediumPaddingHorizontalBox,
    ...largePaddingBottom,
  },
  floatView: {
    ...mediumNegativeMarginTopBox,
    ...largePaddingHorizontalBox,
    ...extraSmallMarginBottomBox,
    alignItems: 'center',
  },
  card: {
    width: '100%',
  },
});
